<ion-menu contentId="main-content" menuId="main-menu" type="overlay">
  <ion-content>
    <ion-list lines="none">
      <ion-menu-toggle auto-hide="false">
        <ion-item
          class="nav-inicio"
          button
          detail="false"
          routerLink="/home"
          routerDirection="root"
          routerLinkActive="active-item"
        >
          <ion-icon slot="start" name="home-outline"></ion-icon>
          <ion-label>Inicio</ion-label>
        </ion-item>
      </ion-menu-toggle>

      <!-- Menú desplegable de Gráficas -->
      @if (showChartsMenu()) {
        <ion-item class="nav-graficas" button detail="false" (click)="toggleChartsMenu()">
          <ion-icon slot="start" name="analytics-outline"></ion-icon>
          <ion-label>{{ 'SIDEBAR.CHARTS' | translate }}</ion-label>
          <ion-icon
            slot="end"
            [name]="chartsMenuExpanded() ? 'chevron-up-outline' : 'chevron-down-outline'"
          ></ion-icon>
        </ion-item>

        @if (chartsMenuExpanded()) {
          <ion-menu-toggle auto-hide="false">
            @if (permissions.hasPermission('view_charts')) {
              <ion-item
                button
                detail="false"
                class="nav-graficas sub-item"
                routerLink="/charts/general"
                routerDirection="root"
                routerLinkActive="active-item"
              >
                <ion-icon slot="start" name="pie-chart-outline"></ion-icon>
                <ion-label>{{ 'SIDEBAR.CHARTS_GENERAL' | translate }}</ion-label>
              </ion-item>
            }
            <!-- Dashboard de facturación de cobranza: vive en /collections/billing
                 pero se navega desde Gráficas (acordado con SAC, 21-sep-2026). -->
            @if (permissions.hasPermission('view_invoices')) {
              <ion-item
                button
                detail="false"
                class="nav-graficas sub-item"
                routerLink="/collections/billing"
                routerDirection="root"
                routerLinkActive="active-item"
              >
                <ion-icon slot="start" name="cash-outline"></ion-icon>
                <ion-label>{{ 'SIDEBAR.CHARTS_COLLECTIONS' | translate }}</ion-label>
              </ion-item>
            }
          </ion-menu-toggle>
        }
      }

      <ion-menu-toggle auto-hide="false">
        <!-- La pantalla de Usuarios es de administración (alta, edición, baja), así
             que pide `edit_users` y no `view_users`. La diferencia importa:
             `view_users` es la lectura del directorio que necesita el selector de
             agentes de Cobranza (GET /users lo valida en GetUsersUseCase), y
             gatear por ahí le dejaría el menú visible a todo Cobranza. -->
        @if (permissions.hasPermission('edit_users')) {
          <ion-item
            class="nav-usuarios"
            button
            detail="false"
            routerLink="/users"
            routerDirection="root"
            routerLinkActive="active-item"
          >
            <ion-icon slot="start" name="people-outline"></ion-icon>
            <ion-label>Usuarios</ion-label>
          </ion-item>
        }
        <ion-item
          class="nav-sistemas"
          button
          detail="false"
          routerLink="/systems"
          routerDirection="root"
          routerLinkActive="active-item"
        >
          <ion-icon slot="start" name="flash-outline"></ion-icon>
          <ion-label>Sistemas</ion-label>
        </ion-item>
        <ion-item
          class="nav-sistemas"
          button
          detail="false"
          routerLink="/addendums"
          routerDirection="root"
          routerLinkActive="active-item"
          data-testid="nav-addendums"
        >
          <ion-icon slot="start" name="flash-outline"></ion-icon>
          <ion-label>Adendums</ion-label>
        </ion-item>
      </ion-menu-toggle>

      <!-- Menú desplegable de Clientes -->
      <ion-item class="nav-clientes" button detail="false" (click)="toggleClientesMenu()">
        <ion-icon slot="start" name="people-circle-outline"></ion-icon>
        <ion-label>Clientes</ion-label>
        <ion-icon
          slot="end"
          [name]="clientesMenuExpanded() ? 'chevron-up-outline' : 'chevron-down-outline'"
        ></ion-icon>
      </ion-item>

      @if (clientesMenuExpanded()) {
        <ion-menu-toggle auto-hide="false">
          <ion-item
            button
            detail="false"
            class="nav-clientes sub-item"
            routerLink="/customers"
            routerDirection="root"
            routerLinkActive="active-item"
          >
            <ion-icon slot="start" name="people-circle-outline"></ion-icon>
            <ion-label>Directorio</ion-label>
          </ion-item>
          <!-- TODO: Restaurar guard @if (permissions.hasPermission('resolve_customer_links')) — por ahora pública para cualquier usuario -->
          <ion-item
            button
            detail="false"
            class="nav-clientes sub-item"
            routerLink="/customers/consolidation"
            routerDirection="root"
            routerLinkActive="active-item"
          >
            <ion-icon slot="start" name="link-outline"></ion-icon>
            <ion-label>Consolidación de clientes</ion-label>
          </ion-item>
        </ion-menu-toggle>
      }

      <!-- Menú desplegable de App Clientes (clientes.terraenergy.mx). Grupo
           propio porque va a crecer con más módulos de la app; hoy solo el
           listado de usuarios: quién ya inició sesión y quién tiene el acceso
           listo sin estrenar (view_customer_app_accounts, migración 074). -->
      @if (showAppClientesMenu()) {
        <ion-item class="nav-app-clientes" button detail="false" (click)="toggleAppClientesMenu()">
          <ion-icon slot="start" name="phone-portrait-outline"></ion-icon>
          <ion-label>App Clientes</ion-label>
          <ion-icon
            slot="end"
            [name]="appClientesMenuExpanded() ? 'chevron-up-outline' : 'chevron-down-outline'"
          ></ion-icon>
        </ion-item>

        @if (appClientesMenuExpanded()) {
          <ion-menu-toggle auto-hide="false">
            @if (permissions.hasPermission('view_customer_app_accounts')) {
              <ion-item
                button
                detail="false"
                class="nav-app-clientes sub-item"
                routerLink="/customer-app/accounts"
                routerDirection="root"
                routerLinkActive="active-item"
              >
                <ion-icon slot="start" name="people-outline"></ion-icon>
                <ion-label>Usuarios</ion-label>
              </ion-item>
            }
          </ion-menu-toggle>
        }
      }

      <!-- Menú desplegable de Marketing -->
      @if (showMarketingMenu()) {
        <ion-item class="nav-marketing" button detail="false" (click)="toggleMarketingMenu()">
          <ion-icon slot="start" name="megaphone-outline"></ion-icon>
          <ion-label>Marketing</ion-label>
          <ion-icon
            slot="end"
            [name]="marketingMenuExpanded() ? 'chevron-up-outline' : 'chevron-down-outline'"
          ></ion-icon>
        </ion-item>

        @if (marketingMenuExpanded()) {
          <ion-menu-toggle auto-hide="false">
            @if (permissions.hasPermission('view_lead_acquisition_analytics')) {
              <ion-item
                button
                detail="false"
                class="nav-marketing sub-item"
                routerLink="/marketing/acquisition"
                routerDirection="root"
                routerLinkActive="active-item"
              >
                <ion-icon slot="start" name="stats-chart-outline"></ion-icon>
                <ion-label>Adquisición</ion-label>
              </ion-item>
            }
            @if (permissions.hasPermission('view_leads')) {
              <ion-item
                button
                detail="false"
                class="nav-marketing sub-item"
                routerLink="/marketing/leads"
                routerDirection="root"
                routerLinkActive="active-item"
              >
                <ion-icon slot="start" name="people-outline"></ion-icon>
                <ion-label>Leads</ion-label>
              </ion-item>
            }
            @if (permissions.hasPermission('view_lead_email_blocklist')) {
              <ion-item
                button
                detail="false"
                class="nav-marketing sub-item"
                routerLink="/marketing/blocked-emails"
                routerDirection="root"
                routerLinkActive="active-item"
              >
                <ion-icon slot="start" name="ban-outline"></ion-icon>
                <ion-label>Correos bloqueados</ion-label>
              </ion-item>
            }
            @if (permissions.hasPermission('view_lead_acquisition_costs')) {
              <ion-item
                button
                detail="false"
                class="nav-marketing sub-item"
                routerLink="/marketing/lead-costs"
                routerDirection="root"
                routerLinkActive="active-item"
              >
                <ion-icon slot="start" name="cash-outline"></ion-icon>
                <ion-label>Costos por canal</ion-label>
              </ion-item>
            }
            @if (permissions.hasPermission('manage_lead_referrals')) {
              <ion-item
                button
                detail="false"
                class="nav-marketing sub-item"
                routerLink="/marketing/leads/referrals"
                routerDirection="root"
                routerLinkActive="active-item"
              >
                <ion-icon slot="start" name="person-add-outline"></ion-icon>
                <ion-label>Referidos pendientes</ion-label>
              </ion-item>
            }
          </ion-menu-toggle>
        }
      }

      <!-- Menú desplegable de Ventas -->
      @if (showVentasMenu()) {
        <ion-item class="nav-ventas" button detail="false" (click)="toggleVentasMenu()">
          <ion-icon slot="start" name="briefcase-outline"></ion-icon>
          <ion-label>Ventas</ion-label>
          <ion-icon
            slot="end"
            [name]="ventasMenuExpanded() ? 'chevron-up-outline' : 'chevron-down-outline'"
          ></ion-icon>
        </ion-item>

        @if (ventasMenuExpanded()) {
          <ion-menu-toggle auto-hide="false">
            @if (permissions.hasPermission('view_quotes')) {
              <ion-item
                button
                detail="false"
                class="nav-ventas sub-item"
                routerLink="/sales/quotes"
                routerDirection="root"
                routerLinkActive="active-item"
              >
                <ion-icon slot="start" name="document-text-outline"></ion-icon>
                <ion-label>Cotizaciones</ion-label>
              </ion-item>
            }
            @if (permissions.hasPermission('view_coverage')) {
              <ion-item
                button
                detail="false"
                class="nav-ventas sub-item"
                routerLink="/sales/coverage"
                routerDirection="root"
                routerLinkActive="active-item"
              >
                <ion-icon slot="start" name="map-outline"></ion-icon>
                <ion-label>Cobertura</ion-label>
              </ion-item>
            }
          </ion-menu-toggle>
        }
      }

      <!-- Menú desplegable de Cobranza -->
      @if (showCobranzaMenu()) {
        <ion-item class="nav-cobranza" button detail="false" (click)="toggleCobranzaMenu()">
          <ion-icon slot="start" name="cash-outline"></ion-icon>
          <ion-label>Cobranza</ion-label>
          <ion-icon
            slot="end"
            [name]="cobranzaMenuExpanded() ? 'chevron-up-outline' : 'chevron-down-outline'"
          ></ion-icon>
        </ion-item>

        @if (cobranzaMenuExpanded()) {
          <ion-menu-toggle auto-hide="false">
            @if (permissions.hasPermission('view_collection_processing')) {
              <ion-item
                button
                detail="false"
                class="nav-cobranza sub-item"
                routerLink="/collections/processing"
                routerDirection="root"
                routerLinkActive="active-item"
              >
                <ion-icon slot="start" name="wallet-outline"></ion-icon>
                <ion-label>Pasarelas de pago</ion-label>
              </ion-item>
            }
            @if (permissions.hasPermission('view_direct_debit')) {
              <ion-item
                button
                detail="false"
                class="nav-cobranza sub-item"
                routerLink="/collections/direct-debit"
                routerDirection="root"
                routerLinkActive="active-item"
              >
                <ion-icon slot="start" name="card-outline"></ion-icon>
                <ion-label>Domiciliación</ion-label>
              </ion-item>
            }
            <!-- Facturación del mes por esquema; lanzar y operar la corrida pide además
                 run_collection_invoicing, que la página revisa por su cuenta. -->
            @if (permissions.hasPermission('view_collection_invoicing')) {
              <ion-item
                button
                detail="false"
                class="nav-cobranza sub-item"
                routerLink="/collections/invoicing"
                routerDirection="root"
                routerLinkActive="active-item"
              >
                <ion-icon slot="start" name="document-text-outline"></ion-icon>
                <ion-label>Facturación</ion-label>
              </ion-item>
            }
            @if (permissions.hasPermission('view_agent_assignments')) {
              <ion-item
                button
                detail="false"
                class="nav-cobranza sub-item"
                routerLink="/collections/agent-assignments"
                routerDirection="root"
                routerLinkActive="active-item"
              >
                <ion-icon slot="start" name="person-add-outline"></ion-icon>
                <ion-label>Agentes</ion-label>
              </ion-item>
            }
            <!-- Sin gating por permiso todavía: el dashboard de KPIs se abre a
                 quien vea el grupo de Cobranza (fase RBAC pendiente). -->
            <ion-item
              button
              detail="false"
              class="nav-cobranza sub-item"
              routerLink="/collections/agent-kpis"
              routerDirection="root"
              routerLinkActive="active-item"
            >
              <ion-icon slot="start" name="stats-chart-outline"></ion-icon>
              <ion-label>KPIs de agentes</ion-label>
            </ion-item>
            @if (permissions.hasPermission('view_pending_tasks')) {
              <ion-item
                button
                detail="false"
                class="nav-cobranza sub-item"
                routerLink="/collections/pending-tasks"
                routerDirection="root"
                routerLinkActive="active-item"
              >
                <ion-icon slot="start" name="alarm-outline"></ion-icon>
                <ion-label>Pendientes</ion-label>
              </ion-item>
            }
            @if (permissions.hasPermission('approve_payment_receipts')) {
              <ion-item
                button
                detail="false"
                class="nav-cobranza sub-item"
                routerLink="/collections/payment-receipts"
                routerDirection="root"
                routerLinkActive="active-item"
              >
                <ion-icon slot="start" name="receipt-outline"></ion-icon>
                <ion-label>Comprobantes de pago</ion-label>
              </ion-item>
            }
            @if (permissions.hasPermission('view_payment_receipts')) {
              <ion-item
                button
                detail="false"
                class="nav-cobranza sub-item"
                routerLink="/collections/credit-balances"
                routerDirection="root"
                routerLinkActive="active-item"
              >
                <ion-icon slot="start" name="wallet-outline"></ion-icon>
                <ion-label>Saldos a favor</ion-label>
              </ion-item>
            }
            @if (permissions.hasPermission('view_collection_orders')) {
              <ion-item
                button
                detail="false"
                class="nav-cobranza sub-item"
                routerLink="/collections/free-months"
                routerDirection="root"
                routerLinkActive="active-item"
              >
                <ion-icon slot="start" name="gift-outline"></ion-icon>
                <ion-label>Meses gratis</ion-label>
              </ion-item>
            }
          </ion-menu-toggle>
        }
      }

      <!-- Menú desplegable de Supply Chain -->
      @if (showSupplyChainMenu()) {
        <ion-item class="nav-supply-chain" button detail="false" (click)="toggleSupplyChainMenu()">
          <ion-icon slot="start" name="cube-outline"></ion-icon>
          <ion-label>Supply Chain</ion-label>
          <ion-icon
            slot="end"
            [name]="supplyChainMenuExpanded() ? 'chevron-up-outline' : 'chevron-down-outline'"
          ></ion-icon>
        </ion-item>

        @if (supplyChainMenuExpanded()) {
          <ion-menu-toggle auto-hide="false">
            @if (permissions.hasPermission('view_supply_chain_analytics')) {
              <ion-item
                button
                detail="false"
                class="nav-supply-chain sub-item"
                routerLink="/supply-chain/analytics"
                routerDirection="root"
                routerLinkActive="active-item"
              >
                <ion-icon slot="start" name="analytics-outline"></ion-icon>
                <ion-label>Indicadores</ion-label>
              </ion-item>
            }
            @if (permissions.hasPermission('view_inventory_catalog')) {
              <ion-item
                button
                detail="false"
                class="nav-supply-chain sub-item"
                routerLink="/supply-chain/items"
                routerDirection="root"
                routerLinkActive="active-item"
              >
                <ion-icon slot="start" name="list-outline"></ion-icon>
                <ion-label>Artículos</ion-label>
              </ion-item>
            }
            @if (permissions.hasPermission('view_panel_availability')) {
              <ion-item
                button
                detail="false"
                class="nav-supply-chain sub-item"
                routerLink="/supply-chain/availability"
                routerDirection="root"
                routerLinkActive="active-item"
              >
                <ion-icon slot="start" name="map-outline"></ion-icon>
                <ion-label>Disponibilidad</ion-label>
              </ion-item>
            }
          </ion-menu-toggle>
        }
      }

      <!-- Menú desplegable de Asset Management -->
      @if (showAssetManagementMenu()) {
        <ion-item
          class="nav-asset-management"
          button
          detail="false"
          (click)="toggleAssetManagementMenu()"
        >
          <ion-icon slot="start" name="trophy-outline"></ion-icon>
          <ion-label>Asset Management</ion-label>
          <ion-icon
            slot="end"
            [name]="assetManagementMenuExpanded() ? 'chevron-up-outline' : 'chevron-down-outline'"
          ></ion-icon>
        </ion-item>

        @if (assetManagementMenuExpanded()) {
          <ion-menu-toggle auto-hide="false">
            <ion-item
              button
              detail="false"
              class="nav-asset-management sub-item"
              routerLink="/asset-management/loyalty"
              routerDirection="root"
              routerLinkActive="active-item"
            >
              <ion-icon slot="start" name="gift-outline"></ion-icon>
              <ion-label>Puntos Terra</ion-label>
            </ion-item>
          </ion-menu-toggle>
        }
      }

      <!-- Menú desplegable de Recursos Humanos -->
      @if (showRhMenu()) {
        <ion-item class="nav-rh" button detail="false" (click)="toggleRhMenu()">
          <ion-icon slot="start" name="id-card-outline"></ion-icon>
          <ion-label>Recursos Humanos</ion-label>
          <ion-icon
            slot="end"
            [name]="rhMenuExpanded() ? 'chevron-up-outline' : 'chevron-down-outline'"
          ></ion-icon>
        </ion-item>

        @if (rhMenuExpanded()) {
          <ion-menu-toggle auto-hide="false">
            @if (permissions.hasPermission('view_org_chart')) {
              <ion-item
                button
                detail="false"
                class="nav-rh sub-item"
                routerLink="/rh/organigrama"
                routerDirection="root"
                routerLinkActive="active-item"
              >
                <ion-icon slot="start" name="git-network-outline"></ion-icon>
                <ion-label>Organigrama Empresarial</ion-label>
              </ion-item>
            }
            @if (permissions.hasPermission('view_employee_files')) {
              <ion-item
                button
                detail="false"
                class="nav-rh sub-item"
                routerLink="/rh/expedientes"
                routerDirection="root"
                routerLinkActive="active-item"
              >
                <ion-icon slot="start" name="folder-open-outline"></ion-icon>
                <ion-label>Expedientes</ion-label>
              </ion-item>
            }
          </ion-menu-toggle>
        }
      }

      <!-- Menú desplegable de Tickets -->
      <ion-item class="nav-tickets" button detail="false" (click)="toggleTicketsMenu()">
        <ion-icon slot="start" name="ticket-outline"></ion-icon>
        <ion-label>Tickets</ion-label>
        <ion-icon
          slot="end"
          [name]="ticketsMenuExpanded() ? 'chevron-up-outline' : 'chevron-down-outline'"
        ></ion-icon>
      </ion-item>

      @if (ticketsMenuExpanded()) {
        <ion-menu-toggle auto-hide="false">
          <!-- Sin guard de permiso: levantar un ticket y ver los propios no lleva
               permiso, y hoy casi nadie en la empresa tiene permisos asignados. -->
          <ion-item
            button
            detail="false"
            class="nav-tickets sub-item"
            routerLink="/tickets/ti"
            routerDirection="root"
            routerLinkActive="active-item"
          >
            <ion-icon slot="start" name="desktop-outline"></ion-icon>
            <ion-label>Tickets T.I.</ion-label>
          </ion-item>
          @if (permissions.hasPermission('view_ticket_kpis')) {
            <ion-item
              button
              detail="false"
              class="nav-tickets sub-item"
              routerLink="/tickets/ti/kpis"
              routerDirection="root"
              routerLinkActive="active-item"
            >
              <ion-icon slot="start" name="stats-chart-outline"></ion-icon>
              <ion-label>KPIs de T.I.</ion-label>
            </ion-item>
          }
          @if (permissions.hasPermission('manage_it_ticket_settings')) {
            <ion-item
              button
              detail="false"
              class="nav-tickets sub-item"
              routerLink="/tickets/ti/configuracion"
              routerDirection="root"
              routerLinkActive="active-item"
            >
              <ion-icon slot="start" name="settings-outline"></ion-icon>
              <ion-label>Configuración de la mesa</ion-label>
            </ion-item>
          }
        </ion-menu-toggle>
      }

      <!-- Menú desplegable de Comunicación. Se muestra si el usuario alcanza
           alguna de sus pantallas: las tres del mailing a clientes con
           `view_mailings` (quien solo lee ve campañas, listas y plantillas sin
           poder enviar ni cargar listas) y Comunicación interna con
           `manage_internal_notifications`, que es solo de T.I. -->
      @if (showComunicacionMenu()) {
        <ion-item class="nav-comunicacion" button detail="false" (click)="toggleComunicacionMenu()">
          <ion-icon slot="start" name="mail-outline"></ion-icon>
          <ion-label>Comunicación</ion-label>
          <ion-icon
            slot="end"
            [name]="comunicacionMenuExpanded() ? 'chevron-up-outline' : 'chevron-down-outline'"
          ></ion-icon>
        </ion-item>

        @if (comunicacionMenuExpanded()) {
          <ion-menu-toggle auto-hide="false">
            @if (permissions.hasPermission('view_mailings')) {
              <ion-item
                button
                detail="false"
                class="nav-comunicacion sub-item"
                routerLink="/mailing/campaigns"
                routerDirection="root"
                routerLinkActive="active-item"
              >
                <ion-icon slot="start" name="send-outline"></ion-icon>
                <ion-label>Campañas de correo</ion-label>
              </ion-item>
              <ion-item
                button
                detail="false"
                class="nav-comunicacion sub-item"
                routerLink="/mailing/lists"
                routerDirection="root"
                routerLinkActive="active-item"
              >
                <ion-icon slot="start" name="list-outline"></ion-icon>
                <ion-label>Listas de folios</ion-label>
              </ion-item>
              <ion-item
                button
                detail="false"
                class="nav-comunicacion sub-item"
                routerLink="/mailing/templates"
                routerDirection="root"
                routerLinkActive="active-item"
              >
                <ion-icon slot="start" name="document-text-outline"></ion-icon>
                <ion-label>Plantillas</ion-label>
              </ion-item>
            }
            @if (permissions.hasPermission('manage_internal_notifications')) {
              <ion-item
                button
                detail="false"
                class="nav-comunicacion sub-item"
                routerLink="/internal-notifications"
                routerDirection="root"
                routerLinkActive="active-item"
              >
                <ion-icon slot="start" name="notifications-outline"></ion-icon>
                <ion-label>Comunicación interna</ion-label>
              </ion-item>
            }
          </ion-menu-toggle>
        }
      }
    </ion-list>
  </ion-content>
  <!-- Fuera de `ion-content` para que quede fijo abajo aunque la lista haga scroll. -->
  @if (permissions.hasPermission('view_settings')) {
    <ion-footer class="ion-no-border">
      <ion-menu-toggle auto-hide="false">
        <ion-item
          class="nav-configuracion"
          button
          detail="false"
          routerLink="/settings"
          routerDirection="root"
          routerLinkActive="active-item"
        >
          <ion-icon slot="start" name="settings-outline"></ion-icon>
          <ion-label>Configuración</ion-label>
        </ion-item>
      </ion-menu-toggle>
    </ion-footer>
  }
</ion-menu>
